// ── Imports ───────────────────────────────────────────────────────────────────
import PortalDashboard      from "views/portal/PortalDashboard.jsx";
import PortalBiodata        from "views/portal/PortalBiodata.jsx";
import PortalTimetable      from "views/portal/PortalTimetable.jsx";
import PortalEnrollment     from "views/portal/PortalEnrollment.jsx";
import PortalResults        from "views/portal/PortalResults.jsx";
import PortalStatementOfResults from "views/portal/PortalStatementOfResults.jsx";
import PortalFees           from "views/portal/PortalFees.jsx";
import PortalChangePassword from "views/portal/PortalChangePassword.jsx";

// ── Icons ─────────────────────────────────────────────────────────────────────
import DashboardIcon        from "@material-ui/icons/Dashboard";
import PersonIcon           from "@material-ui/icons/Person";
import ScheduleIcon         from "@material-ui/icons/Schedule";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import GradeIcon            from "@material-ui/icons/Grade";
import PaymentIcon          from "@material-ui/icons/Payment";

// ── Route table ───────────────────────────────────────────────────────────────
var studentRoutes = [
  { path: "/portal/dashboard",  name: "Dashboard",  icon: DashboardIcon,          mini: "DB", component: PortalDashboard  },
  { path: "/portal/biodata",    name: "My Biodata", icon: PersonIcon,             mini: "BD", component: PortalBiodata    },
  { path: "/portal/timetable",  name: "Timetable",  icon: ScheduleIcon,           mini: "TT", component: PortalTimetable  },
  { path: "/portal/enrollment", name: "Enrollment", icon: AssignmentTurnedInIcon, mini: "EN", component: PortalEnrollment },
  { path: "/portal/results",    name: "Results",    icon: GradeIcon,              mini: "RS", component: PortalResults    },
  { path: "/portal/fees",       name: "Fees",       icon: PaymentIcon,            mini: "FE", component: PortalFees       },

  // ── Hidden dynamic routes (routing only — not in sidebar) ─────────────────
  { hidden: true, path: "/portal/change-password", component: PortalChangePassword },
  { hidden: true, path: "/portal/statement", component: PortalStatementOfResults },

  // ── Redirect ─────────────────────────────────────────────────────────────
  { redirect: true, path: "/portal", pathTo: "/portal/dashboard", name: "Dashboard" }
];

export default studentRoutes;
